import React from 'react'
import {Header, List, Message, Table} from 'semantic-ui-react'

const ResolveMockContractConflicts = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Resolve Mock/Contract Conflicts</Header>
      <Message>
        <Message.Header>A Few Things To Remember</Message.Header>
        <Message.List>
          <Message.Item>Clicking "Sync" will result in forcefull resolution possibly leading to changes you didn't
            want</Message.Item>
          <Message.Item>"Sync" could still result in conflicts that don't go away. This is because you need to
            fix/update the contract to fix these.</Message.Item>
        </Message.List>
      </Message>
      <p>
        Your mock and it's contract should remain aligned but in some cases conflicts arise.
        Service Mocks will add/update/remove resources in your contract when you make these
        changes in your mock but there are many aspects that Service Mocks leaves in
        your hands because the contract is a very fine grained place to define, express,
        and control your mock behavior.
      </p>
      <p>
        Consequently, there will be cases where Service Mocks detects differences, or conflicts.
        When this happens a warning panel will be shown along with a "Resolve Conflicts" button.
        When you click this you can work through each conflict which will involve either removing
        things in your mock or fixing specifications in your contract definition.
      </p>
      <Header as='h3' dividing>Conflict Types</Header>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Type</Table.HeaderCell>
            <Table.HeaderCell>Description</Table.HeaderCell>
            <Table.HeaderCell>How To Resolve</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>Resource Orphaned</Table.Cell>
            <Table.Cell>Resource exists in Mock but not in contract</Table.Cell>
            <Table.Cell>Remove resource from mock</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Response Orphaned</Table.Cell>
            <Table.Cell>Response exists in Mock but not in contract</Table.Cell>
            <Table.Cell>Remove response from mock</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Response Schema Issues</Table.Cell>
            <Table.Cell>Contract response def. conflicts with response headers/body in mock</Table.Cell>
            <Table.Cell>Update mock response headers/body or change contract definition</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
      <Header as='h3' dividing>Steps</Header>
      <List relaxed>
        <List.Item>1. Navigate to the service you wish to work with</List.Item>
        <List.Item>2. Click "Mock" tab</List.Item>
        <List.Item>3. You'll see a warning panel with "View Conflicts" button when they exist</List.Item>
        <List.Item>4. Click "View Conflicts".</List.Item>
        <List.Item>5. Work through each conflict using resolutions described above.</List.Item>
        <List.Item>6. Or click "Sync" which will try to forcefully resolve all conflicts.</List.Item>
      </List>
    </div>
  )
}

export {ResolveMockContractConflicts}

export default ResolveMockContractConflicts